import * as React from 'react'
import { cn } from '@/lib/utils'

interface MaskInputDinProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'onChange'> {
  value?: number
  onChange?: (value: number) => void
  className?: string
}

/**
 * Input que exibe R$ 1.234,56 e retorna número com casas decimais corretas
 */
export const MaskInputDin: React.FC<MaskInputDinProps> = ({ value = 0, onChange, className, ...props }) => {
  // estado interno com o texto formatado
  const [display, setDisplay] = React.useState('')

  // sempre que `value` mudar, atualiza o texto formatado
  React.useEffect(() => {
    setDisplay(
      value.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })
    )
  }, [value])

  // handle de digitação/colagem
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    // pega só dígitos
    const onlyDigits = e.target.value.replace(/\D/g, '')
    // transforma em número: últimas duas casas são centavos
    const num = parseInt(onlyDigits || '0', 10) / 100
    // formata de novo pra exibição
    const formatted = num.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })
    setDisplay(formatted)
    onChange?.(num)
  }

  return (
    <input
      {...props}
      type="text"
      className={cn(
        'flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50',
        className
      )}
      value={display}
      onChange={handleChange}
    />
  )
}
